// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, MenuItem } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import {
  deleteSalesOrderRequisitionConfig,
  getSalesOrderRequisitionConfigs,
} from "../../features/salesOrderRequisitionConfig";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";

const SalesOrderRequisitionConfig = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { configs, status } = useSelector(
    (state: any) => state.salesOrderRequisitionConfig
  );

  const [data, setData] = useState([]);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this configuration?"
    );
    if (isConfirmed) {
      dispatch(deleteSalesOrderRequisitionConfig(id))
        .then((res) => {
          toast.success(res.payload?.message || "Deleted successfully");
          dispatch(getSalesOrderRequisitionConfigs());
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const columns = [
    {
      header: "Company Code",
      accessorKey: "companyCode",
      id: "companyCode",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Plant",
      accessorKey: "plant",
      id: "plant",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Sales Org",
      accessorKey: "salesOrg",
      id: "salesOrg",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Distribution Channel",
      accessorKey: "distributionChannel",
      id: "distributionChannel",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Division",
      accessorKey: "division",
      id: "division",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        return (
          <div>
            <ActionMenu sx={{ width: "50px" }}>
              <MenuItem
                onClick={() =>
                  navigate(`/sale-order-requisition-configuration/edit/${id}`)
                }
              >
                Edit
              </MenuItem>
              <MenuItem onClick={() => handleDelete(id)}>Delete</MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getSalesOrderRequisitionConfigs());
  }, [dispatch]);

  useEffect(() => {
    if (status && Array.isArray(configs)) {
      setData(configs);
    }
  }, [status, configs]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold">
                Sales Order Requisition Configuration
              </SoftTypography>
              <SoftButton
                onClick={() =>
                  navigate("/sale-order-requisition-configuration/add")
                }
                variant="contained"
                color="final"
              >
                Add Configuration
              </SoftButton>
            </SoftBox>
            <Table
              columns={columns}
              data={data}
              pageIndex={1}
              pageSize={Math.max(data.length, 1)}
              totalRows={data.length}
              onPageChange={() => {}}
              onPageSizeChange={() => {}}
            />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default SalesOrderRequisitionConfig;
